import React, { Component } from 'react'
import PropTypes from 'prop-types'
import IPropTypes from 'react-immutable-proptypes'
import { FormattedMessage } from 'react-intl'
import Tooltip, { POSITION, ALIGN } from 'gnos-tooltip'
import cx from 'classnames'

import { LOCALE_PREFIX } from '../../../../constants'

import './style.scss'

export default class SingleEntityContentButton extends Component {
    static propTypes = {
        group: IPropTypes.map,
        handleAddToGroup: PropTypes.func.isRequired,
        handleRemoveFromGroup: PropTypes.func.isRequired,
        index: PropTypes.number.isRequired,
        inGroup: PropTypes.bool,
        loading: PropTypes.bool,
    }

    handleBtnClick = () => {
        const { group, inGroup, handleAddToGroup, handleRemoveFromGroup, index } = this.props

        const groupId = group.get('id', null)

        if (!groupId) return null

        if (!inGroup) {
            handleAddToGroup(groupId, index)
        } else {
            handleRemoveFromGroup(groupId, index)
        }

        return null
    }

    render() {
        const { inGroup, loading, index } = this.props

        return (
            <div className={'se-content-btn'}>
                <Tooltip
                    id={`manage-group-add-btn-tooltip-${index}`}
                    content={
                        <FormattedMessage id={`${LOCALE_PREFIX}.${!inGroup ? 'addBtnTooltip' : 'removeBtnTooltip'}`} />
                    }
                    position={POSITION.TOP}
                    align={ALIGN.CENTER}
                >
                    <button
                        className={cx('group-control-btn', !inGroup ? 'add' : 'remove', loading && 'loading')}
                        onClick={this.handleBtnClick}
                    />
                </Tooltip>
            </div>
        )
    }
}
